import IPayload from "../interfaces/IPayload";
import IRevisaoCotaInstalacao from "../interfaces/IRevisaoCotaInstalacao";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class RevisaoCotaInstalacaoService {
    async getById(id: string) {
        return await api.get<IRevisaoCotaInstalacao>(`${resources.revisaoCotaInstalacao}/GetById/${id}`);
    }

    async create(data: any) {
        return await api.post<IRevisaoCotaInstalacao>(`${resources.revisaoCotaInstalacao}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.revisaoCotaInstalacao}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.revisaoCotaInstalacao}/Delete/${id}`);
    }

    async approve(id: any) {
        return await api.put<any>(`${resources.revisaoCotaInstalacao}/Approve/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.revisaoCotaInstalacao}/GetWithFilter/${ToQueryString(filters)}`);
    }
}

export default new RevisaoCotaInstalacaoService();
